import {
	postYiqifeiXServicesRequest,
	postBIZServicesRequest,
	postYiqifeiAPIEncryptDataRequest
} from '@/utils/request'
var webconfig = require('@/utils/webconfig.js');

const yqfApi = {
	/**
	 * 获取最低价日历
	 * @description 文档地址：https://api.yiqifei.com/Doc/Serving?id=6e50d7619b3ff71d355e8b716c0317ff
	 */	
	GetMinPriceCalendar(parm, callback) {
		postYiqifeiXServicesRequest('ShoppingServer.MinPriceCalendarGet', parm, function(result) {
			callback(result);
		})
	},	
	/**
	 * 获取用户最近的会话列表
	 * @description 文档地址：https://api.yiqifei.com/Doc/Serving?id=5c97142527fb93886ff54fcd9919bf46	 
	 */	
	GetUserRecentlySessionList(parm, callback) {
		postYiqifeiXServicesRequest('BaseComm.Feifei.GetUserRecentlySessionList', parm, function(result) {
			callback(result);
		})
	},
	/**
	 * 获取飞飞用户凭证
	 * @description 文档地址：https://api.yiqifei.com/Doc/Serving?id=5c97142527fb93886ff54fcd9919bf46	 
	 */	
	GetFeifeiAuth(parm, callback) {
		postYiqifeiXServicesRequest('BaseComm.Feifei.FeifeiAuth', parm, function(result) {
			callback(result);
		})
	},	
	/**
	 * 备注、留言、行程单、退改签留言
	 * @description 文档地址：https://api.yiqifei.com/Doc/Serving?id=73b810d84e02b3de881b9793b00a96ca
	 */	
	GetSalesOrderMessageAdd(parm, callback) {
		postYiqifeiXServicesRequest('LvRui.SalesOrderMessageAdd', parm, function(result) {
			callback(result);
		})
	},	
};

export default yqfApi;